<template>
  <div class="data-detail-list" v-loading="loading">
    <dataDetail> </dataDetail>
  </div>
</template>

<script>
import { getIncomeDayList, exportIncome } from '@/api/income';
import { formatStartTime, formatEndTime } from '@/utils';
// import Table from '../../components/table';
import dataDetail from '../../dataDetail.vue';
import { $vi18n } from '@/utils/i18n.js';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
export default {
  name: 'indexPageTable',
  components: {
    // Table,
    dataDetail,
  },
  data() {
    return {
      loading: false,
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      IncomePageCount: 0,
      incomeDate: '',
      defaultStart:
        new Date(
          new Date(new Date() - 3600 * 1000 * 24 * 7).toString(),
        ).getTime() / 1000, // 0$vi18n('$i# 点时间戳 #i18n$')
      defaultEnd:
        new Date(new Date(new Date()).toDateString()).getTime() / 1000 - 1, //23:59:59$vi18n('点时间戳 #i18n$')
      tableData: [],

      tableField: [
        { label: $vi18n('$i18n# 日期 #i18n$'), prop: 'date' },
        {
          label: $vi18n('$i18n# 迷你豆数量 #i18n$'),
          prop: 'minibean',
          explain: $vi18n('$i18n# 玩家使用迷你豆购买了作品或资源 #i18n$'),
        },
        {
          label: $vi18n('$i18n# 迷你点数量 #i18n$'),
          prop: 'minipoint',
          explain: $vi18n('$i18n# 玩家使用迷你点购买了作品或资源 #i18n$'),
        },
        {
          label: $vi18n('$i18n# 贡献点数量 #i18n$'),
          prop: 'contribution',
          explain: $vi18n('$i18n# 玩家使用贡献点购买了作品或资源 #i18n$'),
        },
        // {
        //   label: '$vi18n('$i18n# 广告收入 #i18n$')',
        //   prop: 'ad_income',
        //   explain:
        //     '$vi18n('$i18n# 玩家在作品或资源中观看了广告 #i18n$')（$vi18n('$i18n# 广告收入需要 #i18n$')2$vi18n('$i18n# 日后进账 #i18n$')，$vi18n('$i18n# 请以实际进账金额为准 #i18n$')）'
        // },
        {
          label: $vi18n('$i18n# 触发器广告收入 #i18n$'),
          prop: 'ad_trigger',
          explain:
            $vi18n('$i18n# 在地图作品中，用户通过触发器观看的广告记为内购商店广告，该收入是广告收入的一部分 #i18n$'),
        },
        {
          label: $vi18n('$i18n# 内购商店收入 #i18n$'),
          prop: 'ad_shop',
          explain:
            $vi18n('$i18n# 在地图作品中，用户通过观看开发者商店内商品的广告记为内购商店广告，该收入是广告收入的一部分 #i18n$'),
        },
        {
          label: $vi18n('$i18n# 通行证广告收入 #i18n$'),
          prop: 'ad_passcheck',
          explain:
            $vi18n('$i18n# 在地图作品中，用户通过观看畅玩通行证的广告记为通行证广告，该收入是广告收入的一部分 #i18n$'),
        },
        {
          label: $vi18n('$i18n# 其他广告收入 #i18n$'),
          prop: 'ad_other',
          explain: '',
        },
        // {
        //   label: '$vi18n('$i18n# 广告展示次数 #i18n$')',
        //   prop: 'ad_count',
        //   explain: '$vi18n('$i18n# 在所有作品和资源中广告被观看的次数 #i18n$')'
        // },
        // {
        //   label: '$vi18n('$i18n# 贡献点数量 #i18n$')',
        //   prop: 'contribution',
        //   explain: '$vi18n('$i18n# 平台为作品支付的服务费 #i18n$')'
        // },
        {
          label: $vi18n('$i18n# 其他收入 #i18n$'),
          prop: 'other',
          explain: $vi18n('$i18n# 参加活动、赛事获得奖金收益或激励收益 #i18n$'),
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: $vi18n('$i18n# 最近一周 #i18n$'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: $vi18n('$i18n# 最近一个月 #i18n$'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: $vi18n('$i18n# 最近三个月 #i18n$'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    // this.fetchIncomeList();
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.incomeDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  methods: {
    getMoreIncome() {
      //$vi18n('$# 查看更多收益点击埋点 #i18n$')
      this.$log('check_more_click', 85422, { v7: 1 });
      this.$router.push({ name: 'dataDetail' });
    },
    IncomeDateChange() {
      console.log('IncomeDateChange', this.incomeDate);
    },
    IncomeBtnClicked() {
      this.fetchIncomeList();
    },
    IncomePageChange(currPage) {
      this.tableInfo.page = currPage;
      this.getIncomeDayList();
    },
    exportFn() {
      this.fetchExport();
    },
    //$vi18n('# 导出收益明细数据 #i18n$')
    async fetchExport() {
      let data = {
        start_time: formatStartTime(this.incomeDate[0]),
        end_time: formatEndTime(this.incomeDate[1]),
      };
      try {
        const res = await exportIncome(data);
        this.downloadFile(res.data.url);
        this.$message.success($vi18n('$i18n# 下载成功 #i18n$'));
      } catch (error) {
        console.log(error);
      }
    },
    //$vi18n('$n# 下载数据 #i18n$')
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    //$vi18n('$n# 获取收益明细数据 #i18n$')
    async fetchIncomeList() {
      this.loading = true;
      let data = {
        // $vi18n('$in# 默认请求最近一周 #i18n$')
        start_time: formatStartTime(this.incomeDate[0]),
        end_time: formatEndTime(this.incomeDate[1]),
        // start_time: this.defaultStart,
        // end_time: this.defaultEnd,
        page: this.tableInfo.page,
        page_size: this.tableInfo.pageSize,
      };
      const res = await getIncomeDayList(data);
      this.tableData = res.data.list;
      this.IncomePageCount = res.data.total_count;
      this.tableInfo.total = res.data.total_count;
      this.loading = false;
    },

    changePage(val) {
      this.tableInfo.page = val;
      this.fetchIncomeList();
    },
  },
};
</script>
<style src="@/assets/styles/introduce-common.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
$--color-primary: #fd9b21;

.data-detail-list {
  //margin-top: 52px;

  .deatil-title {
    font-size: 24px;
  }
  .explain-more {
    color: #8c8c8c;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    .btn-more {
      cursor: pointer;
      width: 130px;
      height: 36px;
      background: #fffaed;
      border: 1px solid #ffc973;
      border-radius: 18px;
      font-size: 16px;
      color: $--color-primary;
      line-height: 36px;
      text-align: center;
    }
  }
  .content-inner-wrap {
    margin-top: 30px;
    .data-filter {
      //margin-bottom: 22px;
      .mgr25 {
        margin-right: 25px;
      }
      .search_btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
        color: #595959;
        border-right: 1px solid #d9d9d9;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        background-color: #f4f4f5;
      }
      .download-wrap {
        float: right;
        border-radius: 4px;
        font-size: 11px;
        // font-weight: 600;
        margin-top: 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #2b6ddf;
        img {
          margin-right: 8px;
        }
      }
    }
  }
  .data-filter-page {
    margin-top: 44px;
    text-align: center;
    margin-bottom: 12px !important;
    ::v-deep .el-pagination.is-background .el-pager li,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination.is-background .btn-next {
      width: 31px;
      height: 31px;
      border-radius: 4px;
      margin: 0 4.5px;
      background-color: #fff;
      color: #8c8c8c;
      border: 1px solid #d9d9d9;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #fffaed;
      color: #fd9b21;
      border-color: #ffc973;
    }
  }
}
</style>
